export default defineNuxtPlugin(() => {
  // Only run on client-side
  if (!import.meta.client) return;

  const { canTrackSource } = useCookieConsent();
  const route = useRoute();

  const setSourceCookie = () => {
    try {
      const sourceFromQuery = (route.query?.source as string | undefined) ?? undefined;

      if (!sourceFromQuery) return;

      // Basic sanitization: allow alphanum, dash, underscore, dot, slash, plus
      const sanitized = sourceFromQuery
        .trim()
        .slice(0, 128)
        .replace(/[^A-Za-z0-9._\-+/]/g, '');
      if (!sanitized) return;

      const sourceCookie = useCookie('source', {
        maxAge: 60 * 60 * 24 * 30, // 30 days
        sameSite: 'lax',
        secure: true,
        path: '/',
      });

      // Only set if not already set or different
      if (sourceCookie.value !== sanitized) {
        sourceCookie.value = sanitized;
      }
    } catch (error) {
      console.warn('Error setting source cookie:', error);
    }
  };

  // Set source cookie immediately if consent is already given
  if (canTrackSource.value) {
    setSourceCookie();
  }

  // Expose the function to be called from the composable
  return {
    provide: {
      setSourceCookie,
    },
  };
});
